<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Название</label>
              <div>
                <input
                  @keyup.enter="apply"
                  class="form-control"
                  v-model="currFilters.name"
                />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Маршрут активен</label>
              <select
                @keyup.enter="apply"
                class="form-control"
                v-model="currFilters.isActive"
              >
                <option v-for="item in yesNoList" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex">
        <button-component class="col-6" @click="apply"
          >Применить</button-component
        >
        <button-component class="col-6" kind="secondary" @click="reset"
          >Сбросить</button-component
        >
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/common/ui/ButtonComponent";
import Constants from "../../../common/constants";

export default {
  name: "RoutesFilters",
  components: { ButtonComponent },
  props: {
    filters: Object,
  },
  data() {
    return {
      currFilters: this.filters,
      yesNoList: Constants.yesNoList,
    };
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        name: "",
        isActive: null,
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";

.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
.select2::v-deep {
  .select2-container {
    width: 100%;
  }
  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    top: 7px !important;
  }

  .select2-selection__rendered {
    font-size: 1.2em;
  }
}
</style>
